import axiosInstance from "./AxiosInstance";

const BASE_URL = "/api/v3/parking/recaudo/";
const CAJAS_URL = "/api/v3/parking/cajas/";

export const FacturacionService = {
  getRecaudo: (params = {}) => {
    return axiosInstance.get(BASE_URL, { params });
  },

  getTotales: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}totales/`, { params });
  },

  getRecaudoPorUrl: (url) => {
    return axiosInstance.get(url);
  },

  exportRecaudo: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}export/`, { params });
  },

  getNotasRecaudo: (params = {}) => {
    return axiosInstance.get("/api/v3/vigilancia/visitantes-comentarios/", {
      params,
    });
  },

  getCajas: (params = {}) => {
    return axiosInstance.get(CAJAS_URL, { params });
  },
};

export default FacturacionService;
